import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=46b3d8e3"
import script from "./CopyItem.vue?vue&type=script&lang=js"
export * from "./CopyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports